/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgProgressListSuccess = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9.707 2.707 5 7.414 2.293 4.707l1.414-1.414L5 4.586l3.293-3.293zM8.293 8.793l1.414 1.414L5 14.914l-2.707-2.707 1.414-1.414L5 12.086zm0 7.5 1.414 1.414L5 22.414l-2.707-2.707 1.414-1.414L5 19.586zM22 5H11V3h11zm0 8H11v-2h11zm-7 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm3.25 1.707 2.854-2.853-.707-.707-2.147 2.146-.896-.896-.707.707z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgProgressListSuccess as ProgressListSuccess };
